import { useFileUpload as useFileUploadREST } from '@risksmart-app/components/src/file/useFileUpload';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useFileUploadTRPC } from './useFileUploadTRPC';

/**
 * Flag-gated wrapper over the V2 REST upload flow
 * (`@risksmart-app/components/src/file/useFileUpload`) and its tRPC twin.
 * Consumers import THIS — never `useFileUploadTRPC` directly.
 *
 * Bespoke by decision (RSP-6330): NOT built with `createMutationHook`. The
 * legacy branch is a REST flow (presign + raw-axios S3 PUT + save), not an
 * Apollo document, and the tRPC twin composes two tanstack mutations per
 * file — the factory models exactly one Apollo document + one tRPC
 * procedure. The `*TRPC` twin therefore stays as a separate file with its
 * own direct test.
 */
export const useFileUpload = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const restUpload = useFileUploadREST();
  const trpcUpload = useFileUploadTRPC();

  return trpcEnabled ? trpcUpload : restUpload;
};
